import { TimberBuyerProfile } from '@features/TimberBuyer/Profile/TimberBuyerProfile'
import { useTimberBuyerContext } from '@features/TimberBuyer/TimberBuyerContext'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/timberbuyer/$timberBuyerId/sales-agreements/')({
  component: SalesAgreementsRoute,
  staticData: {
    breadcrumb: 'Salgsavtaler',
  },
})

function SalesAgreementsRoute() {
  const { timberBuyerId } = Route.useParams()
  const { data, isLoading, isError } = useTimberBuyerContext()

  return (
    <TimberBuyerProfile
      timberBuyerId={timberBuyerId}
      activePage="salesAgreements"
      data={data}
      isLoading={isLoading}
      isError={isError}
    />
  )
}
